export const RMConst = {
  Position: {
    LEFT_TOP: "LEFT_TOP",
    TOP: "TOP",
    RIGHT_TOP: "RIGHT_TOP",
    LEFT: "LEFT",
    CENTER: "CENTER",
    RIGHT: "RIGHT",
    LEFT_BOTTOM: "LEFT_BOTTOM",
    BOTTOM: "BOTTOM",
    RIGHT_BOTTOM: "RIGHT_BOTTOM",
  },

  Size: {
    SMALL: "SMALL",
    MEDIUM: "MEDIUM",
    LARGE: "LARGE",
  },

  Map: {
    MapFramework: {
      LEAFLET: "LEAFLET",
      GOOGLE: "GOOGLE",
    },

    MapStyle: {
      STREET: "STREET",
      LIGHT: "LIGHT",
      DARK: "DARK",
    },

    TileSource: {
      MAPBOX: "MAPBOX",
      MAPBOX_CHINA: "MAPBOX_CHINA",
    },
  },

  SearchType: {
    NO_PORT: "NO_PORT",
    JUST_HUBS: "JUST_HUBS",
    PORT_BURST: "PORT_BURST",
    PORT_PAIR: "PORT_PAIR",
  },

  CalloutBehavior: {
    OPEN_ALWAYS: "OPEN_ALWAYS",
    OPEN_ONMOUSEOVER: "OPEN_ONMOUSEOVER",
  },

  FlightDirection: {
    OUTBOUND: "outbound",
    RETURN: "return",
  },

  FlightType: {
    DIRECTS: "directs",
    CONNECTIONS: "connections",
  },
};
